import axios from 'axios';

import {
  Market,
  FilterType,
  Credentials,
  UserData,
  User,
  ChartData,
  TradingHistoryItem,
  Comment,
  TickerTrade,
  HolderDistribution,
  FeaturedMarket,
  NonceResponse,
  LoginResponse,
  SendTokenBody,
  TradingHistoryCommentsSummary,
  PurchaseTokenPayload, LeaderboardItem
} from '../types';

import { priceData } from './chart-data';

// TODO - move to wrangler.toml
const API_URL = 'https://weirdly-fun-backend.stevenmahana.workers.dev';
export const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
    'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNzI4NDkxMzU5LCJleHAiOjE3Mjg0OTQ5NTl9.LKijkeJZaQ-AggZGUB6-j3EJCSt0tAiTCRY07YZhsuw',
    'Key': '6TbxVxhLhualgeAMrmISjwvdUiceQzsaEXnB9d5C'
  },
});

export const setAuthToken = (token: string) => {
  api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
};

export const clearAuthToken = () => {
  delete api.defaults.headers.common['Authorization'];
};

export const getNonce = async (address: string): Promise<NonceResponse> => {
  const response = await api.get(`/auth/nonce?address=${address}`);
  return response.data;
};

export const login = async (token: string): Promise<LoginResponse> => {
  const response = await api.post('/auth/login', { token });
  return response.data;
};

export const logout = async () => {
  const response = await api.post('/auth/logout');
  return response.data;
};

export const fetchMarkets = async (filter: FilterType): Promise<Market[]> => {

  if (filter === 'new') {
    const getResponse = await api
      .get('/page/home')
      .then((response) => response.data)
      .catch((err) => console.log(err));

    return getResponse.message || null
  } else {
    const getResponse = await api
      .get(`/token/filter/${filter}`)
      .then((response) => response.data)
      .catch((err) => console.log(err));

    return getResponse.message || null
  }
};

export const fetchSortedMarkets = async (filter: string): Promise<Market[]> => {
    const getResponse = await api
      .get(`/token/filter/${filter}`)
      .then((response) => response.data)
      .catch((err) => console.log(err));

    return getResponse.message || null
};

export const fetchFeaturedMarkets = async (): Promise<FeaturedMarket> => {
  const getResponse = await api
    .get('/page/featured')
    .then((response) => response.data)
    .catch((err) => console.log(err));

  return getResponse.message[0] || null
};

export const signIn = async (credentials: Credentials): Promise<User> => {
  // Simulate API call delay
  await new Promise(resolve => setTimeout(resolve, 1000));

  // Mock authentication logic
  if (credentials.email === 'user@example.com' && credentials.password === 'password') {
    return {
      id: '1',
      email: credentials.email,
      username: 'user123',
      address: '123456789',
      token: '123456789',
    };
  } else {
    throw new Error('Invalid credentials');
  }
};

export const signUp = async (userData: UserData): Promise<User> => {
  // Simulate API call delay
  await new Promise(resolve => setTimeout(resolve, 1000));

  // Mock sign-up logic
  // In a real application, you would validate the data and create a new user
  return {
    id: '2',
    email: userData.email,
    username: userData.username,
    address: '123456789',
    token: '123456789',
  };
};

export const fetchMarketDetails = async (id: string): Promise<Market | null> => {
  const getResponse = await api
    .get(`/page/token/${id}`)
    .then((response) => response.data)
    .catch((err) => console.log(err));

  return getResponse.message || null

};

export const searchTokens = async (query: string): Promise<Market[] | null> => {

  if (query.length === 0) return null

  const getResponse = await api
    .get(`/token/search/${query}`)
    .then((response) => response.data)
    .catch((err) => console.log(err));

  return getResponse.message || null
};

export const fetchLaunchedTodayRanking = async (): Promise<LeaderboardItem[]> => {
  const getResponse = await api
    .get(`/leaderboard/recent`)
    .then((response) => response.data)
    .catch((err) => console.log(err));

  return getResponse.message || null
};

export const fetchChartData = async (id: string): Promise<ChartData[]> => {
  // In a real application, you would fetch this data from your backend
  // This is a mock implementation
  return priceData
};

export const fetchMarketCapRanking = async (): Promise<LeaderboardItem[]> => {
  const getResponse = await api
    .get(`/leaderboard/marketcap`)
    .then((response) => response.data)
    .catch((err) => console.log(err));

  return getResponse.message || null
};

export const fetch24hrPriceIncreaseRanking = async (): Promise<LeaderboardItem[]> => {
  const getResponse = await api
    .get(`/leaderboard/price`)
    .then((response) => response.data)
    .catch((err) => console.log(err));

  return getResponse.message || null
};

export const fetchLaunchingSoonRanking = async (): Promise<LeaderboardItem[]> => {
  const getResponse = await api
    .get(`/leaderboard/queue`)
    .then((response) => response.data)
    .catch((err) => console.log(err));

  return getResponse.message || null
};

/* fetch "more" trades - return next 10 trades  */
export const fetchTradingHistory = async (id: string, page: number = 1): Promise<TradingHistoryItem[]> => {
  const getResponse = await api
    .get(`/trade/trades/${id}?page=${page}`)
    .then((response) => response.data)
    .catch((err) => console.log(err));

  return getResponse.message || null
};

/* fetch "more" comments - return next 10 comments  */
export const fetchComments = async (id: string, page: number = 1): Promise<Comment[]> => {
  const getResponse = await api
    .get(`/token/comments/${id}?page=${page}`)
    .then((response) => response.data)
    .catch((err) => console.log(err));

  return getResponse.message || null
};

/* post comment  */
export const postComment = async (id: string, walletAddress: string, comment: string): Promise<Boolean> => {

  const getResponse = await api
    .post(`/token/comment/${id}`, { walletAddress, comment })
    .then((response) => response.data)
    .catch((err) => console.log(err));

  return getResponse.error === 0;
};

/* post sentiment  */
export const postSentiment = async (id: string, walletAddress: string, sentiment: string): Promise<Boolean> => {

  const getResponse = await api
    .post(`/token/sentiment/${id}`, { walletAddress, sentiment })
    .then((response) => response.data)
    .catch((err) => console.log(err));

  return getResponse.error === 0;
};

/* purchase token  */
export const purchaseToken = async (id: string, payload: PurchaseTokenPayload): Promise<Boolean> => {

  const getResponse = await api
    .post(`/trade/buy/${id}`, payload)
    .then((response) => response.data)
    .catch((err) => console.log(err));

  return getResponse.error === 0;
};

/* sell token  */
export const sellToken = async (id: string, payload: PurchaseTokenPayload): Promise<Boolean> => {

  const getResponse = await api
    .post(`/trade/sell/${id}`, payload)
    .then((response) => response.data)
    .catch((err) => console.log(err));

  return getResponse.error === 0;
};

/* ticker  */
export const fetchRecentTrades = async (): Promise<TickerTrade[]> => {

  const getResponse = await api
    .get('/trade/recent')
    .then((response) => response.data)
    .catch((err) => console.log(err));

  return getResponse.message || [];
};

/* send tokens to friend  */
export const sendTokensToFriend = async (id: string, payload: SendTokenBody): Promise<Boolean> => {
  const getResponse = await api
    .post(`/token/send/friend/${id}`, payload)
    .then((response) => response.data)
    .catch((err) => console.log(err));

  return getResponse.error === 0;
};

/* send tokens to developer  */
export const sendTokensToDeveloper = async (id: string, payload: SendTokenBody): Promise<Boolean> => {
  const getResponse = await api
    .post(`/token/send/developer/${id}`, payload)
    .then((response) => response.data)
    .catch((err) => console.log(err));

  return getResponse.error === 0;
};

/* fetch last 10 trades and comments for initial page load */
export const fetchTradingHistoryAndCommentsSummary = async (id: string): Promise<TradingHistoryCommentsSummary> => {
  const getResponse = await api
    .get(`/trade/trades-comments/${id}`)
    .then((response) => response.data)
    .catch((err) => console.log(err));

  return getResponse.message || null
};

export const fetchHolderDistribution = async (id: string): Promise<HolderDistribution[]> => {
  const getResponse = await api
    .get(`/trade/holder-distribution/${id}`)
    .then((response) => response.data)
    .catch((err) => console.log(err));

  return getResponse.message || null
};